import React from 'react';
import {Stack} from '@mui/material';
import {
  designSystemToken,
  Icon,
  SwitchButton,
  Tooltip,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';

function LipSyncToggle({
  title,
  onChange,
  enabled,
}: {
  title: string;
  onChange: (value: boolean) => void;
  enabled: boolean;
}) {
  return (
    <Tooltip
      title={title}
      arrow
      type="light"
      placement="top"
      sx={{
        width: '182px',
        padding: '10px 12px',
        textAlign: 'center',
        fontSize: '14px',
      }}
    >
      <Stack direction="row" alignItems="center" gap="6px">
        <SwitchButton
          label={translate('Lip sync')}
          checked={enabled}
          checkedTrackColor={designSystemToken('semantic.bg.neutral')}
          onChange={(event, checked) => {
            onChange(checked);
          }}
        />
        <Icon
          name="Actions-Info-Line"
          appearance="primary"
          size="small"
          style={{width: '18px', height: '18px'}}
        />
      </Stack>
    </Tooltip>
  );
}

export default LipSyncToggle;
